import * as tslib_1 from "tslib";
import { FormControl } from '@angular/forms';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import { Apollo } from 'apollo-angular';
import gql from 'graphql-tag';
import { sentry } from 'sentry';
import { searchManyInputStyles } from '../../base/fc-search-many-input/fc-search-many-input.component';
import english from './i18n/en.json';
import spanish from './i18n/es.json';
import portuguese from './i18n/pt.json';
var SEARCH_QUERY = gql(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  query searchSegments($where: SegmentWhereInput, $limit: Int, $offset: Int) {\n    segments(\n      where: $where\n      orderBy: name_asc\n      limit: $limit\n      offset: $offset\n    ){\n      items {\n        id\n        name\n        archived\n      }\n    }\n  }\n"], ["\n  query searchSegments($where: SegmentWhereInput, $limit: Int, $offset: Int) {\n    segments(\n      where: $where\n      orderBy: name_asc\n      limit: $limit\n      offset: $offset\n    ){\n      items {\n        id\n        name\n        archived\n      }\n    }\n  }\n"])));
var FcSegmentsInputComponent = /** @class */ (function () {
    function FcSegmentsInputComponent(fuseTranslationLoaderService, apollo) {
        this.fuseTranslationLoaderService = fuseTranslationLoaderService;
        this.apollo = apollo;
        this.shouldDisplayArchived = false;
        this.desiredStyle = searchManyInputStyles.Select;
        this.disabled = false;
        this.fuseTranslationLoaderService.loadJsonTranslations({ english: english, portuguese: portuguese, spanish: spanish });
        this.search = this.search.bind(this);
        this.displayWith = this.displayWith.bind(this);
    }
    FcSegmentsInputComponent.prototype.search = function (searchTerm, limit, offset) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var where;
            return tslib_1.__generator(this, function (_a) {
                where = {
                    name_contains: searchTerm,
                };
                if (!this.shouldDisplayArchived) {
                    where['archived'] = false;
                }
                return [2 /*return*/, this.apollo
                        .query({
                        query: SEARCH_QUERY,
                        variables: {
                            where: where,
                            limit: limit,
                            offset: offset
                        },
                    })
                        .toPromise()
                        .then(function (result) { return result.data['segments']['items']; })
                        .catch(function (err) {
                        sentry.captureException(err);
                        return [];
                    })];
            });
        });
    };
    FcSegmentsInputComponent.prototype.displayWith = function (value) {
        return value && value.name;
    };
    return FcSegmentsInputComponent;
}());
export { FcSegmentsInputComponent };
var templateObject_1;
